import { AppActions, AppReducerState } from 'services/App/types';
import { parseError, sort } from 'utils/functions';

const INITIAL_STATE = {
  menuOpen: window.innerWidth <= 1024,

  operatingSystems: [],
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,

  countries: [],
  fetchCountriesIsCompleted: false,
  fetchCountriesIsPending: false,
  fetchCountriesIsError: null,

  networkTypes: [],
  fetchNetworkTypesIsCompleted: false,
  fetchNetworkTypesIsPending: false,
  fetchNetworkTypesIsError: null,
} satisfies AppReducerState;

const appReducer = (previousState: AppReducerState | undefined, action: AppActions): AppReducerState => {
  const state: AppReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    // Menu
    case 'TOGGLE_MENU':
      return { ...state, menuOpen: !state.menuOpen };
    // OSs
    case 'FETCH_OPERATING_SYSTEMS':
      return {
        ...state,
        operatingSystems: sort(action.data ?? [], {
          sortBy: 'name',
          sortDirection: 'ASC',
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case 'FETCH_OPERATING_SYSTEMS_IS_PENDING':
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case 'FETCH_OPERATING_SYSTEMS_IS_ERROR':
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: action.error && typeof action.error === 'object' && 'message' in action.error ? parseError(action.error.message) : action.error,
      };
    // Countries
    case 'FETCH_COUNTRIES':
      return {
        ...state,
        countries: sort(action.data ?? [], {
          sortBy: 'name',
          sortDirection: 'ASC',
        }),

        fetchCountriesIsCompleted: true,
        fetchCountriesIsPending: false,
        fetchCountriesIsError: null,
      };
    case 'FETCH_COUNTRIES_IS_PENDING':
      return {
        ...state,
        fetchCountriesIsCompleted: false,
        fetchCountriesIsPending: true,
        fetchCountriesIsError: null,
      };
    case 'FETCH_COUNTRIES_IS_ERROR':
      return {
        ...state,
        fetchCountriesIsCompleted: true,
        fetchCountriesIsPending: false,
        fetchCountriesIsError:
          action.error && typeof action.error === 'object' && 'message' in action.error ? parseError(action.error.message) : action.error,
      };

    // NETWORK TPES
    case 'FETCH_NETWORK_TYPES':
      return {
        ...state,
        networkTypes: sort(action.data ?? [], {
          sortBy: 'typeDescription',
          sortDirection: 'ASC',
        }),
        fetchNetworkTypesIsCompleted: true,
        fetchNetworkTypesIsPending: false,
        fetchNetworkTypesIsError: null,
      };
    case 'FETCH_NETWORK_TYPES_IS_PENDING':
      return {
        ...state,
        fetchNetworkTypesIsCompleted: false,
        fetchNetworkTypesIsPending: true,
        fetchNetworkTypesIsError: null,
      };
    case 'FETCH_NETWORK_TYPES_IS_ERROR':
      return {
        ...state,
        fetchNetworkTypesIsCompleted: true,
        fetchNetworkTypesIsPending: false,
        fetchNetworkTypesIsError:
          action.error && typeof action.error === 'object' && 'message' in action.error ? parseError(action.error.message) : action.error,
      };

    // Reset
    case 'RESET_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default appReducer;
